import React from "react";
import "../styles.css";
export default class ImageComponent extends React.Component {
    handleShowDialog = () => {
        this.setState({ isOpen: !this.state.isOpen });
        console.log("cliked");
    };

    render() {
        return (
            <div>
                {this.props.isOpen && (
                    <dialog
                        className="dialog"
                        style={{ position: "absolute" }}
                        open
                        onClick={this.props.close}
                    >
                        <img
                            height = "200px"
                            className="image"
                            src={this.props.url }
                            onClick={this.props.close}
                            alt=""
                        />
                    </dialog>
                )}
            </div>
        );
    }
}